import React from 'react';
import { cn } from '@restworld/utils-common';

export const SectionWrapper = ({ className, ...props }: React.HTMLAttributes<HTMLElement>) => (
  <section className={cn('', className)} {...props} />
);
export const SectionHeader = ({ className, ...props }: React.HTMLAttributes<HTMLElement>) => (
  <header className={cn('flex justify-between items-center mb-4', className)} {...props} />
);
export const CardsWrapper = ({ className, ...props }: React.HTMLAttributes<HTMLElement>) => (
  <div className={cn('grid grid-cols-1 gap-4', className)} {...props} />
);
export const SeeMoreButtonWrapper = ({ className, ...props }: React.HTMLAttributes<HTMLElement>) => (
  <div className={cn('grid place-items-center mt-4', className)} {...props} />
);
export const ModalHeaderWrapper = ({ className, ...props }: React.HTMLAttributes<HTMLElement>) => (
  <div
    className={cn(
      'hidden md:flex border-b border-neutral-40 w-full justify-between items-center py-[10.5px] px-4 lg:p-3 lg:pl-10',
      className
    )}
    {...props}
  />
);
export const ModalCardsWrapper = ({ className, ...props }: React.HTMLAttributes<HTMLElement>) => (
  <div
    className={cn(
      'mt-10 pb-2 px-4 mx-auto w-full grid grid-cols-1 gap-4 md:max-h-[600px] lg:grid-cols-3 lg:px-10',
      className
    )}
    {...props}
  />
);
export const SpinnerWrapper = ({ className, ...props }: React.HTMLAttributes<HTMLElement>) => (
  <div className={cn('grid place-items-center w-full pt-10 pb-2', className)} {...props} />
);
export const ModalContentWrapper = ({ className, ...props }: React.HTMLAttributes<HTMLElement>) => (
  <div className={cn('w-full h-full md:p-10 md:pb-10', className)} {...props} />
);
export const ActiveComponentWrapper = ({
  isVisible,
  className,
  ...props
}: { isVisible?: boolean } & React.HTMLAttributes<HTMLElement>) => (
  <div className={cn('h-full', isVisible ? 'block' : 'hidden', className)} {...props} />
);
